<!-- Alle Icons von: https://css.gg/ -->
<span id="mitsIconWrapper" [ngSwitch]="name">
  <!-- Bitte Alphabetisch sortieren !!! -->
  <ng-container *ngSwitchCase="'add'" [ngTemplateOutlet]="add"></ng-container>
  <ng-container *ngSwitchCase="'arrow-down'" [ngTemplateOutlet]="arrowdown"></ng-container>
  <ng-container *ngSwitchCase="'arrow-left'" [ngTemplateOutlet]="arrowleft"></ng-container>
  <ng-container *ngSwitchCase="'arrow-right'" [ngTemplateOutlet]="arrowright"></ng-container>
  <ng-container *ngSwitchCase="'arrow-up'" [ngTemplateOutlet]="arrowup"></ng-container>
  <ng-container *ngSwitchCase="'arrows-v'" [ngTemplateOutlet]="arrowsv"></ng-container>
  <ng-container *ngSwitchCase="'assign'" [ngTemplateOutlet]="assign"></ng-container>
  <ng-container *ngSwitchCase="'cash-register'" [ngTemplateOutlet]="cashregister"></ng-container>
  <ng-container *ngSwitchCase="'check'" [ngTemplateOutlet]="check"></ng-container>
  <ng-container *ngSwitchCase="'check-outline'" [ngTemplateOutlet]="checkoutline"></ng-container>
  <ng-container *ngSwitchCase="'chevron-down'" [ngTemplateOutlet]="chevrondown"></ng-container>
  <ng-container *ngSwitchCase="'chevron-left'" [ngTemplateOutlet]="chevronleft"></ng-container>
  <ng-container *ngSwitchCase="'chevron-right'" [ngTemplateOutlet]="chevronright"></ng-container>
  <ng-container *ngSwitchCase="'chevron-up'" [ngTemplateOutlet]="chevronup"></ng-container>
  <ng-container *ngSwitchCase="'circle'" [ngTemplateOutlet]="circle"></ng-container>
  <ng-container *ngSwitchCase="'close'" [ngTemplateOutlet]="close"></ng-container>
  <ng-container *ngSwitchCase="'close-outline'" [ngTemplateOutlet]="closeoutline"></ng-container>
  <ng-container *ngSwitchCase="'code-slash'" [ngTemplateOutlet]="codeslash"></ng-container>
  <ng-container *ngSwitchCase="'details-less'" [ngTemplateOutlet]="detailsless"></ng-container>
  <ng-container *ngSwitchCase="'distribute-horizontal'" [ngTemplateOutlet]="distributehorizontal"></ng-container>
  <ng-container *ngSwitchCase="'distribute-vertical'" [ngTemplateOutlet]="distributevertical"></ng-container>
  <ng-container *ngSwitchCase="'edit-exposure'" [ngTemplateOutlet]="editexposure"></ng-container>
  <ng-container *ngSwitchCase="'eye'" [ngTemplateOutlet]="eye"></ng-container>
  <ng-container *ngSwitchCase="'file'" [ngTemplateOutlet]="file"></ng-container>
  <ng-container *ngSwitchCase="'file-document'" [ngTemplateOutlet]="filedocument"></ng-container>
  <ng-container *ngSwitchCase="'filter'" [ngTemplateOutlet]="filter"></ng-container>
  <ng-container *ngSwitchCase="'format-justify'" [ngTemplateOutlet]="formatjustify"></ng-container>
  <ng-container *ngSwitchCase="'format-seperator'" [ngTemplateOutlet]="formatseperator"></ng-container>
  <ng-container *ngSwitchCase="'format-text'" [ngTemplateOutlet]="formattext"></ng-container>
  <ng-container *ngSwitchCase="'image'" [ngTemplateOutlet]="image"></ng-container>
  <ng-container *ngSwitchCase="'info'" [ngTemplateOutlet]="info"></ng-container>
  <ng-container *ngSwitchCase="'layout-list'" [ngTemplateOutlet]="layoutlist"></ng-container>
  <ng-container *ngSwitchCase="'link'" [ngTemplateOutlet]="link"></ng-container>
  <ng-container *ngSwitchCase="'list'" [ngTemplateOutlet]="list"></ng-container>
  <ng-container *ngSwitchCase="'log-off'" [ngTemplateOutlet]="logoff"></ng-container>
  <ng-container *ngSwitchCase="'menu-boxed'" [ngTemplateOutlet]="menuboxed"></ng-container>
  <ng-container *ngSwitchCase="'meter-reading'" [ngTemplateOutlet]="meterreading"></ng-container>
  <ng-container *ngSwitchCase="'money-bag'" [ngTemplateOutlet]="moneybag"></ng-container>
  <ng-container *ngSwitchCase="'more-alt'" [ngTemplateOutlet]="morealt"></ng-container>
  <ng-container *ngSwitchCase="'options'" [ngTemplateOutlet]="options"></ng-container>
  <ng-container *ngSwitchCase="'paper-clip'" [ngTemplateOutlet]="paperclip"></ng-container>
  <ng-container *ngSwitchCase="'pen'" [ngTemplateOutlet]="pen"></ng-container>
  <ng-container *ngSwitchCase="'person-christmas'" [ngTemplateOutlet]="personchristmas"></ng-container>
  <ng-container *ngSwitchCase="'play-list-search'" [ngTemplateOutlet]="playlistsearch"></ng-container>
  <ng-container *ngSwitchCase="'push-chevron-down'" [ngTemplateOutlet]="pushchevrondown"></ng-container>
  <ng-container *ngSwitchCase="'push-chevron-left'" [ngTemplateOutlet]="pushchevronleft"></ng-container>
  <ng-container *ngSwitchCase="'push-chevron-right'" [ngTemplateOutlet]="pushchevronright"></ng-container>
  <ng-container *ngSwitchCase="'push-chevron-up'" [ngTemplateOutlet]="pushchevronup"></ng-container>
  <ng-container *ngSwitchCase="'push-left'" [ngTemplateOutlet]="pushleft"></ng-container>
  <ng-container *ngSwitchCase="'push-right'" [ngTemplateOutlet]="pushright"></ng-container>
  <ng-container *ngSwitchCase="'scan'" [ngTemplateOutlet]="scan"></ng-container>
  <ng-container *ngSwitchCase="'search'" [ngTemplateOutlet]="search"></ng-container>
  <ng-container *ngSwitchCase="'select'" [ngTemplateOutlet]="select"></ng-container>
  <ng-container *ngSwitchCase="'smile-sad'" [ngTemplateOutlet]="smilesad"></ng-container>
  <ng-container *ngSwitchCase="'software-download'" [ngTemplateOutlet]="softwaredownload"></ng-container>
  <ng-container *ngSwitchCase="'software-upload'" [ngTemplateOutlet]="softwareupload"></ng-container>
  <ng-container *ngSwitchCase="'sync'" [ngTemplateOutlet]="sync"></ng-container>
  <ng-container *ngSwitchCase="'template'" [ngTemplateOutlet]="template"></ng-container>
  <ng-container *ngSwitchCase="'terminal'" [ngTemplateOutlet]="terminal"></ng-container>
  <ng-container *ngSwitchCase="'trash'" [ngTemplateOutlet]="trash"></ng-container>
  <ng-container *ngSwitchCase="'undo'" [ngTemplateOutlet]="undo"></ng-container>
  <ng-container *ngSwitchCase="'view-grid'" [ngTemplateOutlet]="viewgrid"></ng-container>

  <ng-container *ngSwitchDefault [ngTemplateOutlet]="smilesad"></ng-container>
</span>

<!-- Bitte Alphabetisch sortieren !!! -->
<ng-template #add>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 4C11.4477 4 11 4.44772 11 5V11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13V5C13 4.44772 12.5523 4 12 4Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #arrowdown>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.0001 3.67157L13.0001 3.67157L13.0001 16.4999L16.2426 13.2574L17.6568 14.6716L12 20.3284L6.34314 14.6716L7.75735 13.2574L11.0001 16.5001L11.0001 3.67157Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #arrowleft>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.3284 11.0001V13.0001L7.50011 13.0001L10.7426 16.2426L9.32842 17.6568L3.67157 12L9.32842 6.34314L10.7426 7.75735L7.49988 11.0001L20.3284 11.0001Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #arrowright>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.0378 6.34317L13.6269 7.76069L16.8972 11.0157L3.29211 11.0293L3.29413 13.0293L16.8619 13.0157L13.6467 16.2459L15.0643 17.6568L20.7079 11.9868L15.0378 6.34317Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #arrowup>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.6568 8.96219L16.2393 10.3731L12.9843 7.10285L12.9706 20.7079L10.9706 20.7059L10.9843 7.13806L7.75404 10.3532L6.34314 8.93572L12.0132 3.29211L17.6568 8.96219Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #arrowsv>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.75739 5.04077L9.1716 6.45498L11.0001 4.62652V10H13.0001V4.62661L14.8284 6.45498L16.2426 5.04077L12 0.798126L7.75739 5.04077Z"
      fill="currentColor" />
    <path
      d="M16.2426 18.9593L14.8284 17.545L13.0001 19.3734V14H11.0001V19.3735L9.1716 17.545L7.75739 18.9593L12 23.2019L16.2426 18.9593Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #assign>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 6H10V4H4V10H6V6Z" fill="currentColor" />
    <path d="M10 18H6V14H4V20H10V18Z" fill="currentColor" />
    <path d="M14 6H18V10H20V4H14V6Z" fill="currentColor" />
    <path d="M14 18H18V14H20V20H14V18Z" fill="currentColor" />
    <path
      d="M12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #cashregister>
  <svg width="24" height="24" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M696.8,783.4H103.2c-25.2,0-39.1,0-52.5-6.8c-11.9-6-21.3-15.5-27.4-27.4c-6.8-13.4-6.8-27.3-6.8-52.5V641
	c0-0.6,0-1.2,0-1.8c0-0.6,0.1-1.3,0.2-1.9l33.2-249.2c5.5-41.3,8.5-64.1,20.6-83.1c10.6-16.8,25.8-30.1,43.8-38.4
	c20.4-9.4,43.4-9.4,85.1-9.4h57.6v-75.3H151.4c-13.4,0-22.2,0-31.3-4.6c-8.1-4.1-14.5-10.5-18.6-18.6c-4.6-9.1-4.6-18-4.6-31.3V71.2
	c0-13.4,0-22.2,4.6-31.3c4.1-8.1,10.5-14.5,18.6-18.6c9.1-4.6,18-4.6,31.3-4.6H408c13.4,0,22.2,0,31.3,4.6
	c8.1,4.1,14.5,10.5,18.6,18.6c4.6,9.1,4.6,17.9,4.6,31.3v56.1c0,13.4,0,22.2-4.6,31.3c-4.1,8.1-10.5,14.5-18.6,18.6
	c-9.1,4.6-18,4.6-31.3,4.6H302.2v75.3h298.2c41.7,0,64.6,0,85.1,9.4c18.1,8.3,33.2,21.6,43.8,38.4c12,19,15.1,41.8,20.6,83.1
	l33.2,249.2c0.1,0.6,0.2,1.3,0.2,1.9c0,0.6,0.1,1.2,0,1.8v55.8c0,25.2,0,39.1-6.8,52.5c-6,11.9-15.5,21.3-27.4,27.4
	C735.8,783.4,722,783.4,696.8,783.4z M61.6,663.1v33.6c0,16.4,0,28.3,1.9,32.1c1.7,3.3,4.4,6,7.7,7.7c3.8,1.9,15.6,1.9,32.1,1.9
	h593.5c16.4,0,28.3,0,32.1-1.9c3.3-1.7,6-4.4,7.7-7.7c1.9-3.8,1.9-15.6,1.9-32.1v-33.6H61.6z M64.8,618.1h670.4L705.3,394
	c-4.8-36.2-7.2-54.3-14-65c-6-9.4-14.5-16.9-24.6-21.6c-11.5-5.3-29.8-5.3-66.3-5.3H199.6c-36.5,0-54.8,0-66.3,5.3
	c-10.1,4.7-18.7,12.1-24.6,21.6c-6.8,10.7-9.2,28.8-14,65L64.8,618.1z M417.3,139.8C417.3,139.8,417.3,139.8,417.3,139.8
	C417.3,139.8,417.3,139.8,417.3,139.8z M142.1,139.8C142.1,139.8,142.1,139.8,142.1,139.8C142.1,139.8,142.1,139.8,142.1,139.8z
	 M141.9,136.8c2.6,0.1,6.2,0.1,9.5,0.1H408c3.3,0,6.9,0,9.5-0.1c0.1-2.6,0.1-6.2,0.1-9.5V71.2c0-3.3,0-6.9-0.1-9.5
	c-2.6-0.1-6.2-0.1-9.5-0.1H151.4c-3.3,0-6.9,0-9.5,0.1c-0.1,2.6-0.1,6.2-0.1,9.5v56.1C141.8,130.6,141.8,134.2,141.9,136.8z
	 M420.5,136.6C420.5,136.6,420.5,136.6,420.5,136.6C420.5,136.6,420.5,136.6,420.5,136.6z M138.9,136.6
	C138.9,136.6,138.9,136.6,138.9,136.6z M417.3,58.7C417.3,58.7,417.3,58.7,417.3,58.7C417.3,58.7,417.3,58.7,417.3,58.7z
	 M142.1,58.7C142.1,58.7,142.1,58.7,142.1,58.7C142.1,58.7,142.1,58.7,142.1,58.7z M520.3,543.2c-12.4,0-22.5-10.1-22.5-22.5v-0.4
	c0-12.4,10.1-22.5,22.5-22.5c12.4,0,22.5,10.1,22.5,22.5v0.4C542.8,533.1,532.7,543.2,520.3,543.2z M400,543.2
	c-12.4,0-22.5-10.1-22.5-22.5v-0.4c0-12.4,10.1-22.5,22.5-22.5s22.5,10.1,22.5,22.5v0.4C422.5,533.1,412.4,543.2,400,543.2z
	 M279.7,543.2c-12.4,0-22.5-10.1-22.5-22.5v-0.4c0-12.4,10.1-22.5,22.5-22.5c12.4,0,22.5,10.1,22.5,22.5v0.4
	C302.2,533.1,292.1,543.2,279.7,543.2z M580.5,422.9c-12.4,0-22.5-10.1-22.5-22.5V400c0-12.4,10.1-22.5,22.5-22.5
	c12.4,0,22.5,10.1,22.5,22.5v0.4C603,412.8,592.9,422.9,580.5,422.9z M460.2,422.9c-12.4,0-22.5-10.1-22.5-22.5V400
	c0-12.4,10.1-22.5,22.5-22.5s22.5,10.1,22.5,22.5v0.4C482.7,412.8,472.6,422.9,460.2,422.9z M339.8,422.9
	c-12.4,0-22.5-10.1-22.5-22.5V400c0-12.4,10.1-22.5,22.5-22.5c12.4,0,22.5,10.1,22.5,22.5v0.4C362.3,412.8,352.3,422.9,339.8,422.9z
	 M219.5,422.9c-12.4,0-22.5-10.1-22.5-22.5V400c0-12.4,10.1-22.5,22.5-22.5c12.4,0,22.5,10.1,22.5,22.5v0.4
	C242,412.8,232,422.9,219.5,422.9z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #check>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m10.30507,14.21633l-3.92472,-3.92465l-1.96234,1.96233l5.88706,5.88712l9.81163,-9.81177l-1.96233,-1.96234l-7.8493,7.84932z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #checkoutline>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.2426 16.3137L6 12.071L7.41421 10.6568L10.2426 13.4853L15.8995 7.8284L17.3137 9.24262L10.2426 16.3137Z"
      fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #chevrondown>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.34317 7.75732L4.92896 9.17154L12 16.2426L19.0711 9.17157L17.6569 7.75735L12 13.4142L6.34317 7.75732Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #chevronleft>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.2426 6.34317L14.8284 4.92896L7.75739 12L14.8285 19.0711L16.2427 17.6569L10.5858 12L16.2426 6.34317Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #chevronright>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5858 6.34317L12 4.92896L19.0711 12L12 19.0711L10.5858 17.6569L16.2427 12L10.5858 6.34317Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #chevronup>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.6569 16.2427L19.0711 14.8285L12.0001 7.75739L4.92896 14.8285L6.34317 16.2427L12.0001 10.5858L17.6569 16.2427Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #circle>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #close>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.2253 4.81108C5.83477 4.42056 5.20161 4.42056 4.81108 4.81108C4.42056 5.20161 4.42056 5.83477 4.81108 6.2253L10.5858 12L4.81114 17.7747C4.42062 18.1652 4.42062 18.7984 4.81114 19.1889C5.20167 19.5794 5.83483 19.5794 6.22535 19.1889L12 13.4142L17.7747 19.1889C18.1652 19.5794 18.7984 19.5794 19.1889 19.1889C19.5794 18.7984 19.5794 18.1652 19.1889 17.7747L13.4142 12L19.189 6.2253C19.5795 5.83477 19.5795 5.20161 19.189 4.81108C18.7985 4.42056 18.1653 4.42056 17.7748 4.81108L12 10.5858L6.2253 4.81108Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #closeoutline>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.3394 9.32245C16.7434 8.94589 16.7657 8.31312 16.3891 7.90911C16.0126 7.50509 15.3798 7.48283 14.9758 7.85938L12.0497 10.5866L9.32245 7.66048C8.94589 7.25647 8.31312 7.23421 7.90911 7.61076C7.50509 7.98731 7.48283 8.62008 7.85938 9.0241L10.5866 11.9502L7.66048 14.6775C7.25647 15.054 7.23421 15.6868 7.61076 16.0908C7.98731 16.4948 8.62008 16.5171 9.0241 16.1405L11.9502 13.4133L14.6775 16.3394C15.054 16.7434 15.6868 16.7657 16.0908 16.3891C16.4948 16.0126 16.5171 15.3798 16.1405 14.9758L13.4133 12.0497L16.3394 9.32245Z"
      fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #codeslash>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.325 3.05011L8.66741 20.4323L10.5993 20.9499L15.2568 3.56775L13.325 3.05011Z" fill="currentColor" />
    <path
      d="M7.61197 18.3608L8.97136 16.9124L8.97086 16.8933L3.87657 12.1121L8.66699 7.00798L7.20868 5.63928L1.04956 12.2017L7.61197 18.3608Z"
      fill="currentColor" />
    <path
      d="M16.388 18.3608L15.0286 16.9124L15.0291 16.8933L20.1234 12.1121L15.333 7.00798L16.7913 5.63928L22.9504 12.2017L16.388 18.3608Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #detailsless>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 9C2.44772 9 2 9.44772 2 10C2 10.5523 2.44772 11 3 11H21C21.5523 11 22 10.5523 22 10C22 9.44772 21.5523 9 21 9H3Z"
      fill="currentColor" />
    <path
      d="M3 13C2.44772 13 2 13.4477 2 14C2 14.5523 2.44772 15 3 15H15C15.5523 15 16 14.5523 16 14C16 13.4477 15.5523 13 15 13H3Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #distributehorizontal>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 9H13V15H11V9Z" stroke="currentColor" stroke-opacity="0.5" stroke-width="2" />
    <path d="M5 5V19H7V5H5Z" fill="currentColor" />
    <path d="M17 5V19H19V5H17Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #distributevertical>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 11H15V13H9V11Z" stroke="currentColor" stroke-opacity="0.5" stroke-width="2" />
    <path d="M19 7H5V5H19V7Z" fill="currentColor" />
    <path d="M19 19H5V17H19V19Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #editexposure>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11 7V9H9V11H11V13H13V11H15V9H13V7H11ZM9 15V17H15V15H9Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #eye>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
      fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M12 3C17.5915 3 22.2898 6.82432 23.6219 12C22.2898 17.1757 17.5915 21 12 21C6.40848 21 1.71018 17.1757 0.378052 12C1.71018 6.82432 6.40848 3 12 3ZM12 19C7.52443 19 3.73132 16.0581 2.45723 12C3.73132 7.94186 7.52443 5 12 5C16.4756 5 20.2687 7.94186 21.5428 12C20.2687 16.0581 16.4756 19 12 19Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #file>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M3 5C3 3.34315 4.34315 2 6 2H14C17.866 2 21 5.13401 21 9V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V5ZM13 4H6C5.44772 4 5 4.44772 5 5V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V9H13V4ZM18.584 7C17.9413 5.52906 16.6113 4.4271 15 4.10002V7H18.584Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #filedocument>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 18H17V16H7V18Z" fill="currentColor" />
    <path d="M17 14H7V12H17V14Z" fill="currentColor" />
    <path d="M7 10H11V8H7V10Z" fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M6 2C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V9C21 5.13401 17.866 2 14 2H6ZM6 4H13V9H19V19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19V5C5 4.44772 5.44772 4 6 4ZM15 4.10002C16.6113 4.4271 17.9413 5.52906 18.584 7H15V4.10002Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #filter>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M4.70834 15.4397C5.92663 16.2928 7.3222 16.7038 8.70461 16.7063C9.17977 18.0045 10.0433 19.1753 11.2616 20.0284C14.4284 22.2458 18.7932 21.4762 21.0107 18.3093C23.2281 15.1425 22.4585 10.7777 19.2916 8.56024C18.0734 7.70719 16.6778 7.29621 15.2954 7.29371C14.8202 5.99552 13.9567 4.82467 12.7384 3.97161C9.57158 1.75417 5.20676 2.52381 2.98931 5.69064C0.771871 8.85748 1.54151 13.2223 4.70834 15.4397ZM5.8555 13.8014C6.6016 14.3239 7.44081 14.6142 8.28736 14.6875C8.20112 13.1725 8.60464 11.6187 9.54254 10.2793C10.4804 8.9398 11.8025 8.0292 13.2556 7.59209C12.8972 6.82166 12.3374 6.13235 11.5913 5.60992C9.32924 4.02603 6.21151 4.57577 4.62762 6.8378C3.04373 9.09982 3.59347 12.2176 5.8555 13.8014ZM18.1445 10.1985C17.3984 9.67611 16.5592 9.38581 15.7126 9.31251C15.7989 10.8275 15.3953 12.3813 14.4574 13.7207C13.5195 15.0602 12.1975 15.9708 10.7444 16.4079C11.1028 17.1783 11.6626 17.8676 12.4087 18.3901C14.6707 19.9739 17.7885 19.4242 19.3724 17.1622C20.9562 14.9002 20.4065 11.7824 18.1445 10.1985Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #formatjustify>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H4Z"
      fill="currentColor" />
    <path
      d="M4 9C3.44772 9 3 9.44772 3 10C3 10.5523 3.44772 11 4 11H20C20.5523 11 21 10.5523 21 10C21 9.44772 20.5523 9 20 9H4Z"
      fill="currentColor" />
    <path
      d="M3 14C3 13.4477 3.44772 13 4 13H20C20.5523 13 21 13.4477 21 14C21 14.5523 20.5523 15 20 15H4C3.44772 15 3 14.5523 3 14Z"
      fill="currentColor" />
    <path
      d="M4 17C3.44772 17 3 17.4477 3 18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18C21 17.4477 20.5523 17 20 17H4Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #formatseperator>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5">
      <path
        d="M16 5C16.5523 5 17 4.55229 17 4C17 3.44772 16.5523 3 16 3H8C7.44771 3 7 3.44772 7 4C7 4.55228 7.44771 5 8 5L16 5Z"
        fill="currentColor" />
      <path
        d="M16 7C16.5523 7 17 7.44772 17 8C17 8.55229 16.5523 9 16 9H8C7.44771 9 7 8.55229 7 8C7 7.44772 7.44771 7 8 7H16Z"
        fill="currentColor" />
      <path
        d="M17 12C17 12.5523 16.5523 13 16 13L8 13C7.44771 13 7 12.5523 7 12C7 11.4477 7.44771 11 8 11L16 11C16.5523 11 17 11.4477 17 12Z"
        fill="currentColor" />
      <path
        d="M16 21C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19L8 19C7.44771 19 7 19.4477 7 20C7 20.5523 7.44771 21 8 21H16Z"
        fill="currentColor" />
    </g>
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M21 16C21 16.5523 20.5523 17 20 17L4 17C3.44772 17 3 16.5523 3 16C3 15.4477 3.44772 15 4 15L20 15C20.5523 15 21 15.4477 21 16Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #formattext>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5 3H3V6.5H4V4H6.5V3Z" fill="currentColor" />
    <path d="M8.5 4V3H11V4H8.5Z" fill="currentColor" />
    <path d="M13 4H15.5V3H13V4Z" fill="currentColor" />
    <path d="M17.5 3V4H20V6.5H21V3H17.5Z" fill="currentColor" />
    <path d="M21 8.5H20V11H21V8.5Z" fill="currentColor" />
    <path d="M21 13H20V15.5H21V13Z" fill="currentColor" />
    <path d="M21 17.5H20V20H17.5V21H21V17.5Z" fill="currentColor" />
    <path d="M15.5 21V20H13V21H15.5Z" fill="currentColor" />
    <path d="M11 21V20H8.5V21H11Z" fill="currentColor" />
    <path d="M6.5 21V20H4V17.5H3V21H6.5Z" fill="currentColor" />
    <path d="M3 15.5H4V13H3V15.5Z" fill="currentColor" />
    <path d="M3 11H4V8.5H3V11Z" fill="currentColor" />
    <path d="M11 9.5H7V7.5H17V9.5H13V16.5H11V9.5Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #image>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M7 7C5.34315 7 4 8.34315 4 10C4 11.6569 5.34315 13 7 13C8.65685 13 10 11.6569 10 10C10 8.34315 8.65685 7 7 7ZM6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10Z"
      fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M3 3C1.34315 3 0 4.34315 0 6V18C0 19.6569 1.34315 21 3 21H21C22.6569 21 24 19.6569 24 18V6C24 4.34315 22.6569 3 21 3H3ZM21 5H3C2.44772 5 2 5.44772 2 6V18C2 18.5523 2.44772 19 3 19H7.31374L14.1924 12.1214C15.364 10.9498 17.2635 10.9498 18.435 12.1214L22 15.6863V6C22 5.44772 21.5523 5 21 5ZM21 19H10.1422L15.6066 13.5356C15.9971 13.145 16.6303 13.145 17.0208 13.5356L21.907 18.4217C21.7479 18.7633 21.4016 19 21 19Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #info>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 10.9794C11 10.4271 11.4477 9.97937 12 9.97937C12.5523 9.97937 13 10.4271 13 10.9794V16.9794C13 17.5317 12.5523 17.9794 12 17.9794C11.4477 17.9794 11 17.5317 11 16.9794V10.9794Z"
      fill="currentColor" />
    <path
      d="M12 6.05115C11.4477 6.05115 11 6.49886 11 7.05115C11 7.60343 11.4477 8.05115 12 8.05115C12.5523 8.05115 13 7.60343 13 7.05115C13 6.49886 12.5523 6.05115 12 6.05115Z"
      fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #layoutlist>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 7H7V9H9V7Z" fill="currentColor" />
    <path d="M7 13V11H9V13H7Z" fill="currentColor" />
    <path d="M7 15V17H9V15H7Z" fill="currentColor" />
    <path d="M11 15V17H17V15H11Z" fill="currentColor" />
    <path d="M17 13V11H11V13H17Z" fill="currentColor" />
    <path d="M17 7V9H11V7H17Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #link>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.8284 12L16.2426 13.4142L19.071 10.5858C20.6331 9.02365 20.6331 6.49099 19.071 4.9289C17.509 3.3668 14.9763 3.3668 13.4142 4.9289L10.5858 7.75732L12 9.17154L14.8284 6.34311C15.6095 5.56206 16.8758 5.56206 17.6568 6.34311C18.4379 7.12416 18.4379 8.39049 17.6568 9.17154L14.8284 12Z"
      fill="currentColor" />
    <path
      d="M12 14.8285L13.4142 16.2427L10.5858 19.0711C9.02372 20.6332 6.49106 20.6332 4.92896 19.0711C3.36686 17.509 3.36686 14.9764 4.92896 13.4143L7.75739 10.5858L9.1716 12L6.34317 14.8285C5.56212 15.6095 5.56212 16.8758 6.34317 17.6569C7.12422 18.4379 8.39055 18.4379 9.1716 17.6569L12 14.8285Z"
      fill="currentColor" />
    <path
      d="M14.8285 10.5857C15.219 10.1952 15.219 9.56199 14.8285 9.17147C14.4379 8.78094 13.8048 8.78094 13.4142 9.17147L9.1716 13.4141C8.78107 13.8046 8.78107 14.4378 9.1716 14.8283C9.56212 15.2188 10.1953 15.2188 10.5858 14.8283L14.8285 10.5857Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #list>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M20 4H4C3.44771 4 3 4.44772 3 5V19C3 19.5523 3.44772 20 4 20H20C20.5523 20 21 19.5523 21 19V5C21 4.44771 20.5523 4 20 4ZM4 2C2.34315 2 1 3.34315 1 5V19C1 20.6569 2.34315 22 4 22H20C21.6569 22 23 20.6569 23 19V5C23 3.34315 21.6569 2 20 2H4ZM6 7H8V9H6V7ZM11 7C10.4477 7 10 7.44772 10 8C10 8.55228 10.4477 9 11 9H17C17.5523 9 18 8.55228 18 8C18 7.44772 17.5523 7 17 7H11ZM8 11H6V13H8V11ZM10 12C10 11.4477 10.4477 11 11 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H11C10.4477 13 10 12.5523 10 12ZM8 15H6V17H8V15ZM10 16C10 15.4477 10.4477 15 11 15H17C17.5523 15 18 15.4477 18 16C18 16.5523 17.5523 17 17 17H11C10.4477 17 10 16.5523 10 16Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #logoff>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 4.00894C13.0002 3.45665 12.5527 3.00876 12.0004 3.00854C11.4481 3.00833 11.0002 3.45587 11 4.00815L10.9968 12.0116C10.9966 12.5639 11.4442 13.0118 11.9965 13.012C12.5487 13.0122 12.9966 12.5647 12.9968 12.0124L13 4.00894Z"
      fill="currentColor" />
    <path
      d="M4 12.9917C4 10.7826 4.89541 8.7826 6.34308 7.33488L7.7573 8.7491C6.67155 9.83488 6 11.3349 6 12.9917C6 16.3054 8.68629 18.9917 12 18.9917C15.3137 18.9917 18 16.3054 18 12.9917C18 11.3348 17.3284 9.83482 16.2426 8.74903L17.6568 7.33481C19.1046 8.78253 20 10.7825 20 12.9917C20 17.41 16.4183 20.9917 12 20.9917C7.58172 20.9917 4 17.41 4 12.9917Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #menuboxed>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.01562 6.98193C7.46334 6.98193 7.01562 7.43285 7.01562 7.98513C7.01562 8.53742 7.46334 8.98833 8.01563 8.98833H15.9659C16.5182 8.98833 16.9659 8.53742 16.9659 7.98513C16.9659 7.43285 16.5182 6.98193 15.9659 6.98193H8.01562Z"
      fill="currentColor" />
    <path
      d="M7.01562 12C7.01562 11.4477 7.46334 10.9968 8.01562 10.9968H15.9659C16.5182 10.9968 16.9659 11.4477 16.9659 12C16.9659 12.5523 16.5182 13.0032 15.9659 13.0032H8.01563C7.46334 13.0032 7.01562 12.5523 7.01562 12Z"
      fill="currentColor" />
    <path
      d="M8.0249 15.0122C7.47262 15.0122 7.0249 15.4631 7.0249 16.0154C7.0249 16.5677 7.47262 17.0186 8.0249 17.0186H15.9752C16.5275 17.0186 16.9752 16.5677 16.9752 16.0154C16.9752 15.4631 16.5275 15.0122 15.9752 15.0122H8.0249Z"
      fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #meterreading>
  <svg width="24" height="24" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M400,792.7c-53,0-104.4-10.4-152.9-30.9c-46.8-19.8-88.8-48.1-124.8-84.1c-36.1-36.1-64.4-78-84.1-124.8
	C17.7,504.4,7.3,453,7.3,400s10.4-104.4,30.9-152.9c19.8-46.8,48.1-88.8,84.1-124.8c36.1-36.1,78-64.4,124.8-84.1
	C295.6,17.7,347,7.3,400,7.3s104.4,10.4,152.9,30.9c46.8,19.8,88.8,48.1,124.8,84.1c36.1,36.1,64.4,78,84.1,124.8
	c20.5,48.4,30.9,99.9,30.9,152.9s-10.4,104.4-30.9,152.9c-19.8,46.8-48.1,88.8-84.1,124.8s-78,64.4-124.8,84.1
	C504.4,782.3,453,792.7,400,792.7z M400,57.3c-91.5,0-177.6,35.6-242.3,100.4C93,222.4,57.3,308.5,57.3,400S93,577.6,157.7,642.3
	C222.4,707,308.5,742.7,400,742.7S577.6,707,642.3,642.3S742.7,491.5,742.7,400S707,222.4,642.3,157.7C577.6,93,491.5,57.3,400,57.3
	z M400,629.3c-58.8,0-106.7-47.9-106.7-106.7c0-58.8,47.9-106.7,106.7-106.7c8.6,0,16.9,1,24.9,2.9l117-195.1
	c7.1-11.8,22.5-15.7,34.3-8.6c11.8,7.1,15.7,22.5,8.6,34.3L469.5,441.7c22.8,19.6,37.2,48.6,37.2,80.9
	C506.7,581.4,458.8,629.3,400,629.3z M400,465.9c-31.3,0-56.7,25.4-56.7,56.7s25.4,56.7,56.7,56.7c31.3,0,56.7-25.4,56.7-56.7
	S431.3,465.9,400,465.9z M645.5,425h-0.4c-13.8,0-25-11.2-25-25c0-13.8,11.2-25,25-25h0.4c13.8,0,25,11.2,25,25
	C670.5,413.8,659.3,425,645.5,425z M155.3,425h-0.4c-13.8,0-25-11.2-25-25c0-13.8,11.2-25,25-25h0.4c13.8,0,25,11.2,25,25
	C180.3,413.8,169.1,425,155.3,425z M237,261.6h-0.4c-13.8,0-25-11.2-25-25c0-13.8,11.2-25,25-25h0.4c13.8,0,25,11.2,25,25
	C262,250.4,250.8,261.6,237,261.6z M400.4,179.9H400c-13.8,0-25-11.2-25-25c0-13.8,11.2-25,25-25h0.4c13.8,0,25,11.2,25,25
	C425.4,168.7,414.2,179.9,400.4,179.9z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #moneybag>
  <svg width="24" height="24" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path class="st0" d="M398.2,24.9h3.6c31.4,0,57.5,0,78.3,2.8c21.9,2.9,41.7,9.4,57.6,25.3c15.9,15.9,22.4,35.7,25.3,57.6
	c2.1,15.3,2.6,33.6,2.7,54.8c22.6,0.7,42.8,2,60.7,4.5c40.9,5.5,74,17.1,100.1,43.2c26.1,26.1,37.7,59.2,43.2,100.1
	c5.3,39.8,5.3,90.5,5.3,154.7v3.9c0,64.1,0,114.9-5.3,154.7c-5.5,40.9-17.1,74-43.2,100.1c-26.1,26.1-59.2,37.7-100.1,43.2
	c-39.8,5.3-90.5,5.3-154.7,5.3H328.2c-64.1,0-114.9,0-154.7-5.3c-40.9-5.5-74-17.1-100.1-43.2c-26.1-26.1-37.7-59.2-43.2-100.1
	c-5.3-39.8-5.3-90.5-5.3-154.7v-3.9c0-64.1,0-114.9,5.3-154.7c5.5-40.9,17.1-74,43.2-100.1c26.1-26.1,59.2-37.7,100.1-43.2
	c17.9-2.4,38.1-3.7,60.7-4.5c0.1-21.2,0.7-39.4,2.7-54.8c2.9-21.9,9.4-41.7,25.3-57.6c15.9-15.9,35.7-22.4,57.6-25.3
	C340.7,24.9,366.8,24.9,398.2,24.9z M286.6,164.5c13.2-0.1,27-0.1,41.6-0.1h143.5c14.5,0,28.4,0,41.6,0.1c-0.1-19.9-0.6-34.9-2.3-47
	c-2.2-16.1-5.9-23-10.5-27.5c-4.5-4.5-11.4-8.3-27.5-10.5c-16.9-2.3-39.5-2.3-73.1-2.3s-56.2,0.1-73.1,2.3
	c-16.1,2.2-23,5.9-27.5,10.5c-4.5,4.5-8.3,11.4-10.5,27.5C287.3,129.6,286.8,144.6,286.6,164.5z M180.5,221.7
	c-35.1,4.7-55.3,13.6-70.1,28.3c-14.8,14.8-23.6,35-28.3,70.1c-4.8,35.9-4.9,83.1-4.9,149.7s0.1,113.8,4.9,149.7
	c4.7,35.1,13.6,55.3,28.3,70.1c14.8,14.8,35,23.6,70.1,28.3c35.9,4.8,83.1,4.9,149.7,4.9h139.6c66.5,0,113.8-0.1,149.7-4.9
	c35.1-4.7,55.3-13.6,70.1-28.3c14.8-14.8,23.6-35,28.3-70.1c4.8-35.9,4.9-83.1,4.9-149.7s-0.1-113.8-4.9-149.7
	c-4.7-35.1-13.6-55.3-28.3-70.1c-14.8-14.8-35-23.6-70.1-28.3c-35.9-4.8-83.1-4.9-149.7-4.9H330.2
	C263.7,216.8,216.4,216.9,180.5,221.7z M400,304c14.5,0,26.2,11.7,26.2,26.2v0.4c38,9.6,69.8,39.5,69.8,81.1
	c0,14.5-11.7,26.2-26.2,26.2c-14.5,0-26.2-11.7-26.2-26.2c0-13.4-14.9-32-43.6-32c-28.8,0-43.6,18.6-43.6,32c0,13.4,14.9,32,43.6,32
	c48.3,0,96,33.5,96,84.3c0,41.5-31.8,71.5-69.8,81.1v0.4c0,14.5-11.7,26.2-26.2,26.2c-14.5,0-26.2-11.7-26.2-26.2V609
	c-38-9.6-69.8-39.5-69.8-81.1c0-14.5,11.7-26.2,26.2-26.2c14.5,0,26.2,11.7,26.2,26.2c0,13.4,14.9,32,43.6,32
	c28.8,0,43.6-18.6,43.6-32c0-13.4-14.9-32-43.6-32c-48.3,0-96-33.5-96-84.3c0-41.5,31.8-71.5,69.8-81.1v-0.4
	C373.8,315.8,385.5,304,400,304z" fill="currentColor" />
  </svg>
</ng-template>


<ng-template #morealt>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12Z"
      fill="currentColor" />
    <path
      d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
      fill="currentColor" />
    <path
      d="M18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12C16 13.1046 16.8954 14 18 14Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #options>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M7 3C8.86384 3 10.4299 4.27477 10.874 6H19V8H10.874C10.4299 9.72523 8.86384 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3ZM7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z"
      fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M17 20C15.1362 20 13.5701 18.7252 13.126 17H5V15H13.126C13.5701 13.2748 15.1362 12 17 12C19.2091 12 21 13.7909 21 16C21 18.2091 19.2091 20 17 20ZM17 18C18.1046 18 19 17.1046 19 16C19 14.8954 18.1046 14 17 14C15.8954 14 15 14.8954 15 16C15 17.1046 15.8954 18 17 18Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #paperclip>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 0C16.7614 0 19 2.23858 19 5V17C19 20.866 15.866 24 12 24C8.13401 24 5 20.866 5 17V9H7V17C7 19.7614 9.23858 22 12 22C14.7614 22 17 19.7614 17 17V5C17 3.34315 15.6569 2 14 2C12.3431 2 11 3.34315 11 5V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V6H15V17C15 18.6569 13.6569 20 12 20C10.3431 20 9 18.6569 9 17V5C9 2.23858 11.2386 0 14 0Z"
      fill="currentColor" />
  </svg>
</ng-template>


<ng-template #pen>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M21.2635 2.29289C20.873 1.90237 20.2398 1.90237 19.8493 2.29289L18.9769 3.16525C17.8618 2.63254 16.4857 2.82801 15.5621 3.75165L4.95549 14.3582L10.6123 20.0151L21.2189 9.4085C22.1426 8.48486 22.338 7.1088 21.8053 5.99367L22.6777 5.12132C23.0682 4.7308 23.0682 4.09763 22.6777 3.70711L21.2635 2.29289ZM16.9955 10.8035L10.6123 17.1867L7.78392 14.3582L14.1671 7.9751L16.9955 10.8035ZM18.8138 8.98525L19.8047 7.99429C20.1953 7.60376 20.1953 6.9706 19.8047 6.58007L18.3905 5.16586C18 4.77534 17.3668 4.77534 16.9763 5.16586L15.9853 6.15683L18.8138 8.98525Z"
      fill="currentColor" />
    <path d="M2 22.9502L4.12171 15.1717L9.77817 20.8289L2 22.9502Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #personchristmas>
  <svg width="24" height="24" viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g
      transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -5.684341886080802e-14, -1.4210854715202004e-14)">
      <path
        d="M 349.457 226.248 C 346.38 267.751 314.918 301.607 280.378 301.607 C 245.839 301.607 214.322 267.759 211.299 226.248 C 208.159 183.074 238.774 150.889 280.378 150.889 C 321.983 150.889 352.597 183.859 349.457 226.248 Z"
        fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
      <path
        d="M 280.378 351.847 C 212.084 351.847 142.77 389.526 129.943 460.646 C 128.397 469.218 133.248 477.445 142.22 477.445 L 418.537 477.445 C 427.517 477.445 432.368 469.218 430.822 460.646 C 417.987 389.526 348.672 351.847 280.378 351.847 Z"
        fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" />
    </g>
    <g transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -0.000002000000222324161, -9.01302814483644)">
      <path stroke-width="0"
        d="M 152.352 267.611 C 156.353 267.077 158.467 267.577 162.491 269.301 C 168.353 271.813 180.49 280.014 184.179 284.229 C 186.39 286.755 187.968 288.074 186.996 290.989 C 185.569 295.268 187.457 303.696 186.996 308.451 C 186.588 312.66 183.055 315.773 180.517 318.309 C 178.203 320.623 175.652 322.086 172.631 323.379 C 169.34 324.788 163.976 325.156 161.365 326.196 C 158.06 327.513 145.655 324.408 139.712 324.744 C 133.403 325.101 128.515 318.638 125.594 314.084 C 123.172 310.308 120.267 305.025 123.341 301.692 C 127.706 296.96 122.907 287.73 125.594 284.792 C 127.581 282.62 129.681 278.259 133.199 275.497 C 137.65 272.002 147.056 268.318 152.352 267.611 Z"
        style="stroke-width: 2px; fill: rgb(255, 255, 255); stroke: rgb(255, 255, 255);" />
      <g>
        <g transform="matrix(1, 0, 0, 1, -1.689942, 2.816572)">
          <path stroke-width="0"
            d="M 228.032 229.328 C 226.656 230.74 224.276 233.563 221.46 234.797 C 217.443 236.557 216.54 236.3 212.277 240.446 C 209.757 242.897 207.924 245.422 203.892 246.738 C 201.35 247.568 199.175 247.471 196.29 246.649 C 192.911 245.687 188.814 243.24 185.869 239.608 C 182.258 235.155 178.716 226.363 177.419 220.455 C 176.312 215.414 178.01 211.25 177.419 206.373 C 176.785 201.138 172.755 194.593 173.476 190.036 C 173.926 187.19 181.486 187.177 183.443 185.018 C 183.012 182.588 187.081 178.727 188.168 175.682 C 190.088 170.306 196.438 164.607 202.872 159.261 C 208.389 154.676 209.794 154.24 217.779 151.093 C 219.004 150.377 223.826 149.943 225.182 149.645 C 226.565 149.155 234.292 141.642 235.655 141.216 C 246.494 137.831 245.728 137.967 256.002 135.677 C 264.918 133.688 272.724 129.706 279.661 128.353 C 285.375 127.239 289.259 127.427 294.87 127.227 C 301.296 126.997 308.777 126.243 316.276 127.227 C 324.478 128.303 336.553 133.368 342.189 133.987 C 345.443 134.344 347.589 135.91 349.941 136.502 C 352.715 137.201 355.667 136.041 357.68 138.775 C 359.612 141.399 361.141 146.048 361.149 149.699 C 362.687 150.864 364.087 152.235 365.003 153.421 C 366.369 155.19 366.75 156.343 367.256 159.054 C 367.633 161.071 367.534 164.367 367.439 167.79 C 368.014 168.398 368.525 169.056 368.946 169.757 C 370.752 172.767 371.918 177.96 371.199 181.587 C 371.067 182.251 370.854 182.926 370.577 183.601 C 371.102 184.421 371.549 185.22 371.763 186.093 C 372.293 188.26 372.49 190.017 371.763 192.29 C 370.821 195.229 367.553 206.037 363.911 206.161 C 359.904 206.297 357.412 205.663 353.666 206.408 C 350.952 206.948 347.936 207.213 344.872 206.719 C 344.776 206.793 340.429 210.461 338.141 208.73 C 335.414 206.666 336.393 206.525 331.696 206.303 C 325.853 206.027 321.145 206.674 315.713 206.091 C 311.69 205.659 311.306 203.805 306.136 203.838 C 295.811 203.903 262.106 209.287 251.495 213.414 C 245.503 215.745 244.759 219.897 240.792 221.3 C 237.773 222.369 234.052 222.779 230.713 222.411 C 229.744 223.763 228.869 228.468 228.032 229.328 Z"
            style="stroke-width: 2px; fill: rgb(255, 255, 255); stroke: rgb(255, 255, 255);" />
          <g transform="matrix(0.013627, 0, 0, -0.013512, 70.521057, 363.652496)" fill="currentColor" stroke="none">
            <path
              d="M10565 23423 c-148 -8 -405 -37 -570 -64 -622 -105 -1049 -309 -1772 -850 -544 -407 -952 -758 -1348 -1160 -337 -343 -511 -548 -785 -929 -199 -277 -252 -348 -560 -745 -713 -918 -877 -1176 -1377 -2170 -107 -214 -279 -550 -381 -745 -567 -1084 -759 -1621 -848 -2364 -11 -89 -18 -283 -24 -611 -6 -342 -13 -527 -25 -645 -12 -104 -18 -246 -19 -385 0 -336 14 -385 286 -1003 232 -529 298 -703 399 -1057 85 -296 135 -416 364 -870 226 -448 279 -574 359 -855 79 -278 138 -433 293 -770 148 -320 214 -518 312 -935 34 -143 64 -267 67 -276 3 -11 -14 -21 -68 -38 -368 -119 -567 -302 -716 -661 -73 -176 -113 -340 -131 -534 -11 -114 0 -188 40 -254 l19 -34 -87 -114 c-49 -63 -110 -143 -136 -177 -59 -76 -131 -220 -154 -307 -24 -87 -23 -288 0 -384 42 -168 102 -280 277 -516 148 -199 154 -209 229 -393 117 -284 194 -411 322 -531 91 -86 160 -125 276 -158 71 -20 102 -22 363 -23 l285 -1 100 -31 c452 -138 493 -147 685 -147 191 0 339 35 522 124 56 28 107 50 115 50 7 0 35 -16 62 -35 72 -52 151 -77 246 -78 68 -1 98 5 195 38 300 101 834 428 1045 640 205 204 364 528 437 888 20 95 23 142 22 312 l0 200 -53 199 c-64 246 -70 308 -42 485 45 285 36 417 -35 559 -51 99 -161 202 -295 273 -50 27 -59 37 -84 92 -105 230 -124 264 -196 341 -162 173 -443 357 -614 401 -39 10 -106 15 -200 15 l-141 0 -40 42 c-22 24 -64 75 -93 115 -98 135 -216 227 -339 264 -32 9 -42 17 -38 28 36 113 64 223 103 411 25 123 67 298 94 387 64 215 106 406 184 836 70 390 94 506 155 762 79 335 106 546 145 1140 22 331 33 456 52 575 16 100 17 103 30 75 28 -65 82 -244 93 -305 10 -60 9 -75 -20 -190 -36 -147 -47 -272 -31 -350 20 -94 102 -244 203 -369 90 -112 92 -116 96 -175 3 -33 -1 -112 -9 -176 -18 -158 -16 -310 5 -390 48 -176 162 -326 378 -498 113 -89 144 -128 158 -200 52 -272 112 -407 227 -514 58 -53 105 -79 188 -104 53 -15 72 -16 165 -5 90 10 125 10 245 -5 206 -26 438 -24 542 4 156 40 280 100 410 196 36 27 164 145 284 262 285 279 325 309 514 379 131 49 272 121 365 185 47 33 180 158 360 339 164 165 310 303 345 326 61 40 134 65 190 65 58 0 220 32 302 60 141 48 289 163 483 377 122 135 182 178 291 209 153 45 603 86 974 89 191 2 231 5 300 24 92 25 191 80 267 150 l55 50 86 -30 c114 -39 192 -46 296 -25 150 31 255 81 424 203 51 36 110 74 132 84 79 35 193 50 454 59 277 10 374 21 672 79 l194 38 70 -57 c241 -198 410 -229 657 -121 51 22 125 47 163 55 169 35 435 45 680 26 66 -5 259 -14 429 -20 l309 -12 53 -57 c63 -69 130 -107 221 -126 78 -17 153 -19 153 -6 0 5 22 17 50 26 27 9 84 39 125 66 144 94 139 92 270 73 141 -20 296 -15 450 16 96 19 158 23 485 29 l375 7 91 31 c125 43 222 103 323 198 105 100 183 204 250 334 102 199 117 346 61 621 -37 186 -40 279 -11 470 54 365 34 520 -130 1013 -106 319 -106 319 -169 629 -109 540 -206 746 -484 1036 l-80 83 -11 102 c-8 72 -9 135 -2 215 13 143 -1 225 -54 331 -71 142 -198 256 -336 302 -75 25 -130 27 -323 15 -139 -9 -140 -9 -301 34 -35 10 -36 11 -41 68 -7 75 -51 203 -133 387 -70 159 -99 242 -165 475 -119 420 -203 598 -402 845 -35 44 -120 150 -189 235 -208 259 -284 371 -594 890 -207 348 -331 536 -446 680 -357 448 -826 821 -1469 1171 -321 174 -779 375 -1285 564 -525 197 -812 277 -1595 445 -746 160 -996 226 -1410 372 -378 133 -584 188 -910 242 -373 63 -843 89 -1225 69z m7200 -6688 c33 -9 121 -36 197 -60 198 -64 274 -78 418 -78 137 -1 198 7 429 60 85 19 192 37 238 40 l83 6 68 -46 c128 -84 255 -139 367 -157 85 -14 208 1 382 46 73 19 154 34 180 34 27 0 120 -19 208 -42 l160 -43 219 0 218 0 35 -40 34 -40 -8 -75 c-10 -98 -6 -320 8 -389 28 -140 99 -258 240 -402 103 -106 132 -145 181 -244 67 -133 102 -257 173 -602 45 -223 95 -401 185 -668 119 -352 135 -474 95 -740 -38 -252 -37 -381 4 -585 41 -204 41 -273 0 -353 -76 -150 -177 -265 -274 -313 l-60 -29 -295 -1 c-303 -2 -430 -11 -605 -45 -122 -23 -171 -24 -328 -3 -194 25 -301 4 -447 -90 l-85 -54 -47 44 c-27 25 -82 61 -123 81 l-75 35 -207 9 c-115 5 -305 14 -423 20 -710 37 -978 13 -1257 -112 l-63 -28 -52 35 c-29 20 -80 64 -113 98 -38 39 -82 73 -120 91 -81 40 -151 37 -421 -15 -323 -62 -389 -70 -664 -80 -443 -17 -557 -49 -841 -240 -197 -132 -217 -138 -323 -96 -34 13 -96 30 -138 36 -67 11 -86 10 -144 -4 -93 -23 -178 -69 -243 -131 -79 -74 -104 -80 -301 -77 -91 1 -208 -2 -260 -8 -52 -5 -176 -14 -275 -20 -221 -13 -425 -42 -542 -76 -185 -53 -378 -181 -529 -351 -212 -239 -232 -252 -429 -276 -327 -41 -447 -109 -761 -429 -275 -281 -327 -332 -385 -376 -65 -49 -166 -100 -289 -147 -234 -89 -372 -185 -609 -424 -201 -201 -255 -250 -350 -312 -138 -91 -252 -110 -491 -83 -85 10 -222 18 -303 19 -113 0 -150 4 -156 14 -5 7 -19 63 -31 124 -57 287 -134 406 -407 634 -170 142 -184 178 -157 413 23 201 16 341 -21 435 -39 97 -95 191 -168 281 -124 151 -122 146 -82 302 13 53 29 139 35 190 11 86 10 102 -15 218 -14 69 -59 225 -99 347 -85 254 -93 300 -102 538 -12 298 4 343 138 403 194 88 251 154 558 646 190 305 289 444 412 579 91 100 118 117 224 146 275 73 414 176 669 495 166 208 238 271 411 358 114 57 256 105 499 167 255 66 280 70 570 90 374 26 563 57 730 120 143 53 264 166 398 371 92 141 126 172 245 220 125 50 266 53 945 23 442 -20 724 7 1032 96 191 55 359 133 597 276 292 175 270 169 643 180 513 14 1169 51 1413 79 121 14 406 5 477 -15z m-9677 -2992 c-83 -135 -227 -353 -233 -353 -10 0 78 166 130 245 48 73 131 175 141 175 2 0 -15 -30 -38 -67z m-1453 -6567 c24 -10 57 -46 117 -128 101 -135 179 -208 273 -253 94 -45 152 -55 308 -55 l132 0 74 -41 c97 -53 230 -148 294 -213 43 -42 60 -70 96 -158 74 -184 186 -317 338 -400 113 -62 121 -97 77 -340 -22 -126 -28 -281 -15 -381 7 -49 34 -176 61 -284 46 -178 50 -205 50 -310 0 -311 -167 -733 -357 -902 -109 -97 -431 -299 -688 -432 -82 -42 -160 -80 -172 -83 -16 -5 -35 3 -70 27 -168 121 -354 117 -597 -11 -103 -54 -203 -77 -336 -76 -112 1 -147 9 -420 93 -74 23 -189 53 -255 67 -108 23 -138 25 -295 23 -289 -5 -324 -3 -379 25 -58 30 -86 71 -166 241 -189 399 -221 457 -347 631 -68 94 -143 207 -165 250 -68 130 -80 252 -35 345 22 45 197 284 257 350 76 85 135 224 135 320 0 65 -26 151 -59 198 -27 37 -26 72 3 202 43 187 131 385 214 480 53 59 122 95 328 170 339 122 416 169 715 437 153 137 226 168 484 207 126 18 356 19 400 1z"
              style="stroke: rgb(255, 255, 255);" fill="currentColor" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>


<ng-template #playlistsearch>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.8787 4.87866H3.87872V6.87866H15.8787V4.87866Z" fill="currentColor" />
    <path d="M15.8787 8.87866H3.87872V10.8787H15.8787V8.87866Z" fill="currentColor" />
    <path d="M3.87872 12.8787H11.8787V14.8787H3.87872V12.8787Z" fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M13.7574 12.7573C12.5858 13.9289 12.5858 15.8284 13.7574 17C14.681 17.9236 16.0571 18.1191 17.1722 17.5864L18.7071 19.1213L20.1213 17.7071L18.5864 16.1722C19.1191 15.057 18.9236 13.681 18 12.7573C16.8284 11.5858 14.9289 11.5858 13.7574 12.7573ZM15.1716 15.5858C15.5621 15.9763 16.1953 15.9763 16.5858 15.5858C16.9763 15.1952 16.9763 14.5621 16.5858 14.1716C16.1953 13.781 15.5621 13.781 15.1716 14.1716C14.7811 14.5621 14.7811 15.1952 15.1716 15.5858Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #pushchevrondown>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 7.41421L6.41421 6L12.0711 11.6569L17.7279 6L19.1421 7.41421L12.0711 14.4853L5 7.41421Z"
      fill="currentColor" />
    <path d="M19 16.3432H5V18.3432H19V16.3432Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #pushchevronleft>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.929 5L18.3432 6.41421L12.6863 12.0711L18.3432 17.7279L16.929 19.1421L9.85789 12.0711L16.929 5Z"
      fill="currentColor" />
    <path d="M8 19V5H6V19H8Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #pushchevronright>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.41421 5L6 6.41421L11.6569 12.0711L6 17.7279L7.41421 19.1421L14.4853 12.0711L7.41421 5Z"
      fill="currentColor" />
    <path d="M16.3432 19V5H18.3432V19H16.3432Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #pushchevronup>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 16.929L6.41421 18.3432L12.0711 12.6863L17.7279 18.3432L19.1421 16.929L12.0711 9.85789L5 16.929Z"
      fill="currentColor" />
    <path d="M19 8H5V6H19V8Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #pushleft>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.2877 11.0001V13.0001H7.80237L11.045 16.2428L9.63079 17.657L3.97394 12.0001L9.63079 6.34326L11.045 7.75748L7.80236 11.0001H22.2877Z"
      fill="currentColor" />
    <path d="M3 18V6H1V18H3Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #pushright>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 12.9999V10.9999H15.4853L12.2427 7.75724L13.6569 6.34303L19.3137 11.9999L13.6569 17.6567L12.2427 16.2425L15.4853 12.9999H1Z"
      fill="currentColor" />
    <path d="M20.2877 6V18H22.2877V6H20.2877Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #scan>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 3H13V21H11V3Z" fill="currentColor" />
    <path
      d="M5 8C5 7.44771 5.44772 7 6 7H9V5H6C4.34315 5 3 6.34315 3 8V16C3 17.6569 4.34315 19 6 19H9V17H6C5.44772 17 5 16.5523 5 16V8Z"
      fill="currentColor" />
    <path
      d="M19 8C19 7.44771 18.5523 7 18 7H15V5H18C19.6569 5 21 6.34315 21 8V16C21 17.6569 19.6569 19 18 19H15V17H18C18.5523 17 19 16.5523 19 16V8Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #search>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M18.319 14.4326C20.7628 11.2941 20.542 6.75347 17.6569 3.86829C14.5327 0.744098 9.46734 0.744098 6.34315 3.86829C3.21895 6.99249 3.21895 12.0578 6.34315 15.182C9.22833 18.0672 13.769 18.2879 16.9075 15.8442C16.921 15.8595 16.9351 15.8745 16.9497 15.8891L21.1924 20.1317C21.5829 20.5223 22.2161 20.5223 22.6066 20.1317C22.9971 19.7412 22.9971 19.1081 22.6066 18.7175L18.364 14.4749C18.3493 14.4603 18.3343 14.4462 18.319 14.4326ZM16.2426 5.28251C18.5858 7.62565 18.5858 11.4246 16.2426 13.7678C13.8995 16.1109 10.1005 16.1109 7.75736 13.7678C5.41421 11.4246 5.41421 7.62565 7.75736 5.28251C10.1005 2.93936 13.8995 2.93936 16.2426 5.28251Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #select>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.17154 11.508L7.75732 10.0938L12 5.85113L16.2426 10.0938L14.8284 11.508L12 8.67956L9.17154 11.508Z"
      fill="currentColor" />
    <path d="M9.17154 12.492L7.75732 13.9062L12 18.1489L16.2426 13.9062L14.8284 12.492L12 15.3204L9.17154 12.492Z"
      fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #smilesad>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11Z"
      fill="currentColor" />
    <path
      d="M14 17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17H8C8 14.7909 9.79086 13 12 13C14.2091 13 16 14.7909 16 17H14Z"
      fill="currentColor" />
    <path
      d="M16 10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10C14 9.44772 14.4477 9 15 9C15.5523 9 16 9.44772 16 10Z"
      fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #softwaredownload>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V12.1578L16.2428 8.91501L17.657 10.3292L12.0001 15.9861L6.34326 10.3292L7.75748 8.91501L11 12.1575V5Z"
      fill="currentColor" />
    <path d="M4 14H6V18H18V14H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #softwareupload>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 14.9861C11 15.5384 11.4477 15.9861 12 15.9861C12.5523 15.9861 13 15.5384 13 14.9861V7.82831L16.2428 11.0711L17.657 9.65685L12.0001 4L6.34326 9.65685L7.75748 11.0711L11 7.82854V14.9861Z"
      fill="currentColor" />
    <path d="M4 14H6V18H18V14H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #sync>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.56079 10.6418L6.35394 3.94971L8.25402 5.84979C11.7312 3.6588 16.3814 4.07764 19.41 7.1063L17.9958 8.52052C15.7536 6.27827 12.3686 5.87519 9.71551 7.31128L11.2529 8.84869L4.56079 10.6418Z"
      fill="currentColor" />
    <path
      d="M19.4392 13.3581L17.646 20.0502L15.7459 18.1501C12.2688 20.3411 7.61857 19.9223 4.58991 16.8936L6.00413 15.4794C8.24638 17.7217 11.6313 18.1247 14.2844 16.6887L12.747 15.1512L19.4392 13.3581Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 3V9H21V3H3ZM19 5H5V7H19V5Z" fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 11V21H11V11H3ZM9 13H5V19H9V13Z" fill="currentColor" />
    <path d="M21 11H13V13H21V11Z" fill="currentColor" />
    <path d="M13 15H21V17H13V15Z" fill="currentColor" />
    <path d="M21 19H13V21H21V19Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #terminal>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.0333 14.8284L6.44751 16.2426L10.6902 12L6.44751 7.75733L5.0333 9.17155L7.86172 12L5.0333 14.8284Z"
      fill="currentColor" />
    <path d="M15 14H11V16H15V14Z" fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M2 2C0.895431 2 0 2.89543 0 4V20C0 21.1046 0.89543 22 2 22H22C23.1046 22 24 21.1046 24 20V4C24 2.89543 23.1046 2 22 2H2ZM22 4H2L2 20H22V4Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #trash>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M17 5V4C17 2.89543 16.1046 2 15 2H9C7.89543 2 7 2.89543 7 4V5H4C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H5V18C5 19.6569 6.34315 21 8 21H16C17.6569 21 19 19.6569 19 18V7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H17ZM15 4H9V5H15V4ZM17 7H7V18C7 18.5523 7.44772 19 8 19H16C16.5523 19 17 18.5523 17 18V7Z"
      fill="currentColor" />
    <path d="M9 9H11V17H9V9Z" fill="currentColor" />
    <path d="M13 9H15V17H13V9Z" fill="currentColor" />
  </svg>
</ng-template>

<ng-template #undo>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.33929 4.46777H7.33929V7.02487C8.52931 6.08978 10.0299 5.53207 11.6607 5.53207C15.5267 5.53207 18.6607 8.66608 18.6607 12.5321C18.6607 16.3981 15.5267 19.5321 11.6607 19.5321C9.51025 19.5321 7.58625 18.5623 6.30219 17.0363L7.92151 15.8515C8.83741 16.8825 10.1732 17.5321 11.6607 17.5321C14.4222 17.5321 16.6607 15.2935 16.6607 12.5321C16.6607 9.77065 14.4222 7.53207 11.6607 7.53207C10.5739 7.53207 9.56805 7.87884 8.74779 8.46777L11.3393 8.46777V10.4678H5.33929V4.46777Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #viewgrid>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M5 5C3.34315 5 2 6.34315 2 8V16C2 17.6569 3.34315 19 5 19H19C20.6569 19 22 17.6569 22 16V8C22 6.34315 20.6569 5 19 5H5ZM8 7H5C4.44772 7 4 7.44772 4 8V9H8V7ZM10 7V9H14V7H10ZM16 7V9H20V8C20 7.44771 19.5523 7 19 7H16ZM14 11H10V13H14V11ZM16 13V11H20V13H16ZM14 15H10V17H14V15ZM16 17V15H20V16C20 16.5523 19.5523 17 19 17H16ZM8 17V15H4V16C4 16.5523 4.44772 17 5 17H8ZM8 13V11H4V13H8Z"
      fill="currentColor" />
  </svg>
</ng-template>